import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import SmartLink from "../../../../base/links/smart_link.js";

const contentStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.black,
    textDecoration: "none",
    '&:focus': {
      color: theme.palette.black,
    },
    '&:hover': {
      color: theme.palette.black,
      textDecoration: "underline",
    }
  },
}));

const FileCell = (props) => {
  const { file } = props;
  const classes = contentStyles();

  const onClick = (event) => {
    event.stopPropagation();
  }

  if(!file) {
    return <React.Fragment>
      { "-" }
    </React.Fragment>
  }

  return (
    <a href = { file.url }
    target = { "_blank" }
    className = { classes.fileLink } >
    { file.filename }
    </a>
  )
}

export default FileCell;
